import CountryInput from './component';
import { CountryInputProps } from './types';

export default CountryInput;
export type { CountryInputProps };
